import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { updateServiceAdminEmails } from "../../../actions/servicesActions";

const UpdateAdminEmailsDialog = ({ open, onClose, project, service, onSuccess }) => {
  const dispatch = useDispatch();
  const [adminEmails, setAdminEmails] = useState("");

  useEffect(() => {
    if (service?.notifications?.adminEmails) {
      setAdminEmails(service.notifications.adminEmails.join(", "));
    } else {
      setAdminEmails("");
    }
  }, [service]);

  const handleSave = () => {
    if (!project?._id || !service?._id) return;

    const emailsArray = adminEmails
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email);

    dispatch(
      updateServiceAdminEmails({
        projectId: project._id,
        serviceId: service._id,
        adminEmails: emailsArray,
      })
    );

    if (onSuccess) onSuccess();
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Typography variant="h6">Actualizar Emails de Administradores</Typography>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Proyecto: <strong>{project?.name}</strong>
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Servicio: <strong>{service?.name}</strong>
          </Typography>
          <TextField
            label="Emails de Administradores"
            value={adminEmails}
            onChange={(e) => setAdminEmails(e.target.value)}
            fullWidth
            multiline
            rows={3}
            placeholder="admin1@example.com, admin2@example.com"
            helperText="Separa los emails con comas"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateAdminEmailsDialog;
